import { jsx as _jsx } from "react/jsx-runtime";
import * as styles from "./QuoteWrapper.module.css";
export const QuoteWrapper = ({ children, borderColor, borderWidth, }) => {
    return (_jsx("div", { style: { borderLeftColor: borderColor, borderLeftWidth: borderWidth }, className: styles.container, children: children }));
};
